import { Flex } from '@chakra-ui/react';
import { stopPropagation } from 'utils/event';
import { ActiveToolbar } from './ActiveToolbar';
import { EditToolbar } from './EditToolbar';
import { TableWidgetToolbarProps } from './TableWidgetToolbar.types';

export const TableWidgetToolbar = ({ editor, dispatchUpdateWidget, isEditable }: TableWidgetToolbarProps) => {
  return (
    <Flex onClick={stopPropagation} mr='8px' gap='8px' align='center'>
      {isEditable ? (
        <EditToolbar editor={editor} dispatchUpdateWidget={dispatchUpdateWidget} />
      ) : (
        <ActiveToolbar editor={editor} dispatchUpdateWidget={dispatchUpdateWidget} />
      )}
    </Flex>
  );
};
